//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../Routing/Routing.RouteObjectCollector.js";
import "../no/NXObject.js";
import "../no/SelectObject.js";
let d=[[[1,"ReferenceObject",0,"SelectNXObject",0],[1,"RouteObjectCollector",0,"Routing.RouteObjectCollector",0]],[[[],"GetUnifyCharacteristics",{R_:{unifyCharx:"Routing.CharacteristicList"}},0,0],[["charxType","charxName","charxValue"],"SetUnifyCharacteristics",{},3,0]],[]];
SPLM.Routing.UnifyPathBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.UnifyPathBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;